// @core/api/endpoints/document/publish_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentLifecycleResponse,
  PublishDocumentRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Publish document
 * Publishes an approved document-aware entity, making it available and creating an immutable version snapshot.
 */
export async function PublishDocument(
  target_type: string,
  target_id: string,
  data: PublishDocumentRequest,
  options?: RequestOptions
): Promise<DocumentLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/publish`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<DocumentLifecycleResponse>(requestPath, data, requestOptions);
}
